import { CALL_API/* , Schemas */ } from '../store/api';

export const FETCHING_REQUEST = 'FETCHING_REQUEST';
export const FETCHING_SUCCESS = 'FETCHING_SUCCESS';
export const FETCHING_FAILURE = 'FETCHING_FAILURE';
export const CALCULATING_REQUEST = 'CALCULATING_REQUEST';
export const CALCULATING_SUCCESS = 'CALCULATING_SUCCESS';
export const CALCULATING_FAILURE = 'CALCULATING_FAILURE';
export const SENDING_REQUEST = 'SENDING_REQUEST';
export const SENDING_SUCCESS = 'SENDING_SUCCESS';
export const SENDING_FAILURE = 'SENDING_FAILURE';
export const FETCHING_DETAILS_REQUEST = 'FETCHING_DETAILS_REQUEST';
export const FETCHING_DETAILS_SUCCESS = 'FETCHING_DETAILS_SUCCESS';
export const FETCHING_DETAILS_FAILURE = 'FETCHING_DETAILS_FAILURE';
export const SENDING_TOSF_REQUEST = 'SENDING_TOSF_REQUEST';
export const SENDING_TOSF_SUCCESS = 'SENDING_TOSF_SUCCESS';
export const SENDING_TOSF_FAILURE = 'SENDING_TOSF_FAILURE';



export const calculateFineAmount = (body) => ({
    [CALL_API]: {
        types: [CALCULATING_REQUEST, CALCULATING_SUCCESS, CALCULATING_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'email/gettestviolationemail'
    }
});

export const fetchViolationEmail = (body) => ({
    [CALL_API]: {
        types: [FETCHING_REQUEST, FETCHING_SUCCESS, FETCHING_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'email/gettestviolationemail'
    }
});

export const sendViolationEmail = (body) => ({
    [CALL_API]: {
        types: [SENDING_REQUEST, SENDING_SUCCESS, SENDING_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'email/sendtestviolationemail'
    }
});

export const fetchListingDetail = (id) => ({
    [CALL_API]: {
        types: [FETCHING_DETAILS_REQUEST, FETCHING_DETAILS_SUCCESS, FETCHING_DETAILS_FAILURE],
        method: 'GET',
        endpoint: 'listings/getlistingtrackerdetail/' + id
    }
});

export const sendToSalesForce = (body) => ({
    [CALL_API]: {
        types: [SENDING_TOSF_REQUEST, SENDING_TOSF_SUCCESS, SENDING_TOSF_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/notifyrls'
    }
});